// Static decal kinds and their cells in the decal atlas. Pure data shared by the atlas painter
// (textureGen.ts) and the decal mesh builder (staticDecals.ts); the map generator mirrors the names
// in tools/mapgen/src/types.ts.

export const DECAL_KINDS = [
  "oil",
  "streak",
  "scuff",
  "splat",
  "chevron",
  "arrow",
  "crack",
  "skid",
  "n1",
  "n2",
  "n3",
  "n4",
  "A",
  "B",
  "C",
  "D",
] as const;

export type DecalKind = (typeof DECAL_KINDS)[number];

/** The atlas is a square grid of DECAL_GRID x DECAL_GRID equal cells, row 0 on top. */
export const DECAL_GRID = 4;

/** Fraction of a cell left transparent at each edge, so mip levels do not bleed between cells. */
export const DECAL_CELL_PAD = 0.04;

export interface UvRect {
  readonly u0: number;
  readonly v0: number;
  readonly u1: number;
  readonly v1: number;
}

/**
 * Texture coordinates of a kind's cell (v up: the atlas image is uploaded flipped, so row 0 is the
 * top of the picture and the high v side). `null` for an unknown kind.
 */
export function decalUv(kind: string): UvRect | null {
  const i = (DECAL_KINDS as readonly string[]).indexOf(kind);
  if (i < 0) return null;
  const col = i % DECAL_GRID;
  const row = Math.floor(i / DECAL_GRID);
  const step = 1 / DECAL_GRID;
  return { u0: col * step, u1: (col + 1) * step, v0: 1 - (row + 1) * step, v1: 1 - row * step };
}
